module.exports = __webpack_public_path__ + "img/XBC.5eb5a51d.svg";